import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { Translate } from 'react-jhipster';
import { getEcole, deleteEcole } from './ecole.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const EcoleDeleteModal = (props: RouteComponentProps<{ id: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const ecole = useAppSelector(state => state.ecole.entity);
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getEcole(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push('/ecole');
  };

  const confirmDelete = event => {
    dispatch(deleteEcole(ecole.id));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <Modal
      title="Confirmation de suppression"
      centered
      footer={[
        <Button key="back" onClick={goBack}>
          Annuler
        </Button>,
        <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
          Supprimer
        </Button>,
      ]}
      visible={true}
      closable={false}
    >
      Etes-vous certain de vouloir supprimer l&apos;école {ecole.nom} ?
    </Modal>
  );
};

export default EcoleDeleteModal;
